import { defineComponent as r, createBlock as n, openBlock as a, unref as p, mergeProps as l, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowRight",
  __name: "IconArrowRight",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (a(), n(p(c), l(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", { d: "M15.573 16.47a.75.75 0 0 0 1.06 1.06l4.647-4.646a1.25 1.25 0 0 0 0-1.768L16.634 6.47a.75.75 0 0 0-1.06 1.06l3.719 3.72H3.103a.75.75 0 0 0 0 1.5h16.19l-3.72 3.72" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
